module.exports = __webpack_public_path__ + "static/media/mercado-pago.5f342bd1.png";